import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=2b24cf28"
import script from "./form-group.vue?vue&type=script&setup=true&lang=js"
export * from "./form-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-group.vue?vue&type=style&index=0&id=2b24cf28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports